import { Clipboard } from '@angular/cdk/clipboard';
import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Docuseal } from 'src/model/formJ.model';

@Component({
	selector: 'app-docuseal-history',
	standalone: false,
	templateUrl: './docuseal-history.component.html',
	styleUrl: './docuseal-history.component.scss'
})
export class DocusealHistoryComponent {
	@Input() dsList: Docuseal[] = new Array();
	activeModal = inject(NgbActiveModal);
	clipboard = inject(Clipboard);
	sharedService = inject(SharedService);

	reset() {
		this.activeModal.close();
	}

	copySignLink(link: string, signParty: string) {
		this.clipboard.copy(`${signParty} Sign: ${link}`);
		this.sharedService.openAlert(`Copied the link for ${signParty}, please send the link to ${signParty}!`, ALERT_TYPE.SUCCESS);
	}

	async downloadSignedDoc(docUrl: string) {
		window.open(docUrl, '_blank');
	}
}
